<app-section class="welcome-section">
    <header class="welcome-section__header">
        <h2>{{test.title}}</h2>
        <p [innerHTML]="test.description | breakLines"></p>
    </header>

    <footer class="welcome-section__footer">
        <app-button variant="primary" size="lg" (click)="startTest()">
            Comenzar test
        </app-button>
    </footer>
</app-section>